// external dependencies
import React from 'react'
import styled from '@emotion/styled'
import { MDXProvider } from '@mdx-js/tag'
import { array, string } from 'prop-types'
import MDXRenderer from 'gatsby-mdx/mdx-renderer'
import Image from 'gatsby-image'

// components
import mdxStyles from './mdx-styles'

// constants
import { MQ } from 'utils/styleHelpers'

// styled components
const TopBrandContainer = styled.div`
	margin: 40px 0;

	${MQ.M} {
		margin: 70px 0;

		img {
			margin-bottom: 0;
		}
	}
`

const LogoWrap = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	padding: 0 5px;
	width: 100%;

	> div {
		margin-bottom: 10px;
	}

	${MQ.XS} {
		flex-direction: row;
		justify-content: space-between;
		margin: 0 auto;
		width: 75%;
	}

	${MQ.S} {
		justify-content: space-around;
		width: 60%;
	}

	${MQ.M} {
		max-width: 800px;
		width: 100%;
	}
`

// propTypes
const propTypes = {
	topBrandsMdx: string.isRequired,
	topBrandsLogos: array.isRequired,
}

const SectionTopBrands = ({ topBrandsMdx, topBrandsLogos }) => {
	const mappedLogos = topBrandsLogos.map(logo => {
		return <Image key={topBrandsLogos.indexOf(logo)} fixed={logo.childImageSharp.fixed} />
	})

	return (
		<TopBrandContainer>
			<MDXProvider components={mdxStyles}>
				<MDXRenderer>{topBrandsMdx}</MDXRenderer>
				<LogoWrap>{mappedLogos}</LogoWrap>
			</MDXProvider>
		</TopBrandContainer>
	)
}

SectionTopBrands.propTypes = propTypes

export default SectionTopBrands
